import Skeleton from '../skeleton/Skeleton';
import { StyledOfferDetail, StyledOfferSection } from './OfferDetail.styles';

/** The read view's shape, shown until the offer has arrived. */
const OfferDetailSkeleton = () => (
  <StyledOfferDetail aria-busy="true">
    <main className="detail-main">
      <Skeleton width={72} height={20} radius="6px" />
      <div className="detail-head">
        <div className="detail-identity">
          <Skeleton width={48} height={48} radius="18px" />
          <div>
            <Skeleton width={260} height={28} radius="8px" resp />
            <Skeleton width={340} height={16} radius="6px" margin="8px 0 0" resp />
          </div>
        </div>
        <div className="detail-actions">
          <Skeleton width={80} height={36} radius="14px" />
          <Skeleton width={96} height={36} radius="14px" />
        </div>
      </div>

      <div className="detail-info-grid">
        {[0, 1, 2, 3].map(key => (
          <div key={key} className="detail-info-card">
            <Skeleton width={80} height={12} radius="6px" />
            <Skeleton width={140} height={16} radius="6px" margin="8px 0 0" resp />
          </div>
        ))}
      </div>

      {[0, 1, 2, 3].map(key => (
        <StyledOfferSection key={key}>
          <Skeleton width={120} height={14} radius="6px" />
          <Skeleton width="100%" height={14} radius="6px" margin="14px 0 0" />
          <Skeleton width="85%" height={14} radius="6px" margin="8px 0 0" />
          <Skeleton width="60%" height={14} radius="6px" margin="8px 0 0" />
        </StyledOfferSection>
      ))}
    </main>
  </StyledOfferDetail>
);

export default OfferDetailSkeleton;
